import { Dispatcher2xvjdz9qh940 as Dispatcher } from './gql/GqlQuery.mjs';
import { GqlTrait2wtoeyl3yfalb as GqlTrait } from './gql/GqlTrait.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *perform(query, $completion) {
  return (yield* this.p75().c76(query.d76_1, $completion)).h46();
}
var SdkGraphQueryDispatcherClass;
function SdkGraphQueryDispatcher() {
  if (SdkGraphQueryDispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SdkGraphQueryDispatcher', VOID, VOID, [Dispatcher(), GqlTrait()], [1]);
    SdkGraphQueryDispatcherClass = $;
  }
  return SdkGraphQueryDispatcherClass;
}
//region block: exports
export {
  SdkGraphQueryDispatcher as SdkGraphQueryDispatcher2qog4v6gbj5of,
  perform as perform2q29klyh5l8u,
};
//endregion

//# sourceMappingURL=SdkGraphQueryDispatcher.mjs.map
